<div class="page-container">

  <app-nav></app-nav>

  <main class="main-content">
    <div class="content-wrapper">

      <header class="page-header">
        <div class="header-text">
          <h1 class="page-title">Reporte General</h1>
          <p class="page-subtitle">Análisis de ventas y rendimiento de servicios.</p>
        </div>

        <!-- Selector de sede para SUPER_ADMIN -->
        <div *ngIf="rolUsuario === 'SUPER_ADMIN'" class="sede-selector" style="margin-top: 1rem;">
          <label for="sede-select" style="color: white; font-weight: 600; margin-right: 0.5rem;">Sede:</label>
          <select id="sede-select" [(ngModel)]="sedeSeleccionada" (change)="cargarDatos()"
            style="padding: 0.4rem 1rem; border-radius: 0.5rem; margin-right: 1rem; border: 1px solid #fd0100; background: #181818; color: white;">
            <option *ngFor="let sede of sedesDisponibles" [value]="sede">{{ sede }}</option>
          </select>

          <button class="btn-download-pdf" (click)="descargarPdfGraficas()"
            [disabled]="loading || descargandoPdfGraficas">
            {{ descargandoPdfGraficas ? 'Generando PDF...' : 'Exportar Gráficas' }}
          </button>
        </div>
      </header>

      <div *ngIf="loading" class="loading-state">
        Cargando datos...
      </div>

      <div *ngIf="errorCarga" class="error-banner">
        {{ errorCarga }}
      </div>

      <section class="section-shell" *ngIf="!loading" #dashboardPdfTarget>

        <!-- ✅ BLOQUE: Totales del día actual (órdenes + ventas mostrador) -->
        <header class="section-header">
          <div style="width:100%; margin-bottom:0.3rem;">
            <h2 style="color:#fff; font-size:1.35rem; font-weight:700; margin:0 0 0.18rem 0; letter-spacing:-0.01em;">
              Totales del día actual
            </h2>
            <span style="color:#9fb0c8; font-size:0.93rem; font-weight:500; display:block; text-align:left;">
              (incluye órdenes y ventas mostrador)
            </span>
          </div>
        </header>

        <div class="mini-kpi-strip" style="margin-bottom:1.2rem;">
          <!-- ✅ totalHoy = órdenes del día + mostrador del día -->
          <div class="mini-kpi">
            <span>Hoy</span>
            <strong>{{ totalHoy | currency:'COP':'symbol-narrow':'1.0-0' }}</strong>
          </div>
          <!-- ✅ totalEfectivo = efectivo órdenes + efectivo mostrador día -->
          <div class="mini-kpi">
            <span>Efectivo</span>
            <strong style="color:#00e676">{{ totalEfectivo | currency:'COP':'symbol-narrow':'1.0-0' }}</strong>
          </div>
          <!-- ✅ totalTransferencia = transferencia órdenes + transferencia mostrador día -->
          <div class="mini-kpi">
            <span style="color:#2196f3">Transferencia</span>
            <strong style="color:#2196f3">{{ totalTransferencia | currency:'COP':'symbol-narrow':'1.0-0' }}</strong>
          </div>
        </div>

        <div style="width:100%; margin: 1.2rem 0 0.7rem 0;">
          <h2 style="color:#fff; font-size:1.35rem; font-weight:700; margin:0; letter-spacing:-0.01em;">
            Visualizar gráficas
          </h2>
        </div>

        <div class="dashboard-grid">

          <!-- Card: Ventas del día (totalDiaCompleto = órdenes + mostrador) -->
          <div class="stat-card">
            <div class="card-header">
              <p class="card-label">Ventas del día</p>
              <!-- ✅ totalDiaCompleto = totalHoy que ya suma órdenes + mostrador -->
              <p class="card-value">{{ totalDiaCompleto | currency:'COP':'symbol-narrow':'1.0-0' }}</p>
              <div class="trend-indicator">
                <span class="trend-label">Hoy</span>
                <div class="trend-badge positive">
                  <span class="material-symbols-outlined">payments</span>
                  <span>Ingreso Neto</span>
                </div>
              </div>
            </div>

            <div class="chart-area">
              <svg class="line-chart" viewBox="0 0 472 150" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="gradient-red" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stop-color="#fd0100" stop-opacity="0.4" />
                    <stop offset="100%" stop-color="#fd0100" stop-opacity="0" />
                  </linearGradient>
                </defs>
                <path class="chart-fill"
                  d="M0 109C18.15 109 18.15 21 36.3 21C54.46 21 54.46 41 72.6 41C90.77 41 90.77 93 108.9 93C127.08 93 127.08 33 145.2 33C163.38 33 163.38 101 181.5 101C199.7 101 199.7 61 217.8 61C236 61 236 45 254.1 45C272.3 45 272.3 121 290.4 121C308.6 121 308.6 149 326.7 149C344.9 149 344.9 1 363 1C381.2 1 381.2 81 399.4 81C417.5 81 417.5 129 435.7 129C453.8 129 453.8 25 472 25V149H0V109Z"
                  fill="url(#gradient-red)"></path>
                <path class="chart-stroke"
                  d="M0 109C18.15 109 18.15 21 36.3 21C54.46 21 54.46 41 72.6 41C90.77 41 90.77 93 108.9 93C127.08 93 127.08 33 145.2 33C163.38 33 163.38 101 181.5 101C199.7 101 199.7 61 217.8 61C236 61 236 45 254.1 45C272.3 45 272.3 121 290.4 121C308.6 121 308.6 149 326.7 149C344.9 149 344.9 1 363 1C381.2 1 381.2 81 399.4 81C417.5 81 417.5 129 435.7 129C453.8 129 453.8 25 472 25"
                  fill="none" stroke="#fd0100" stroke-width="3" stroke-linecap="round"></path>
              </svg>
            </div>
          </div>

          <!-- Card: Ventas de la semana (órdenes semana + mostrador semana) -->
          <div class="stat-card">
            <div class="card-header">
              <p class="card-label">Ventas de la semana</p>
              <!-- ✅ totalSemanaCompleto calculado en forkJoin cuando ambos datos están listos -->
              <p class="card-value">{{ totalSemanaCompleto | currency:'COP':'symbol-narrow':'1.0-0' }}</p>
              <div class="trend-indicator">
                <span class="trend-label">Esta Semana</span>
                <div class="trend-badge positive">
                  <span class="material-symbols-outlined">calendar_view_week</span>
                  <span>Acumulado</span>
                </div>
              </div>
            </div>

            <div class="bar-chart-container">
              <div class="bar-group">
                <div class="bar" style="height: 30%;"></div> <span class="bar-label">L</span>
              </div>
              <div class="bar-group">
                <div class="bar" style="height: 50%;"></div> <span class="bar-label">M</span>
              </div>
              <div class="bar-group">
                <div class="bar" style="height: 40%;"></div> <span class="bar-label">X</span>
              </div>
              <div class="bar-group">
                <div class="bar" style="height: 70%;"></div> <span class="bar-label">J</span>
              </div>
              <div class="bar-group">
                <div class="bar" style="height: 55%;"></div> <span class="bar-label">V</span>
              </div>
              <div class="bar-group">
                <div class="bar" style="height: 80%;"></div> <span class="bar-label">S</span>
              </div>
              <div class="bar-group active">
                <div class="bar" style="height: 60%;"></div> <span class="bar-label">D</span>
              </div>
            </div>
          </div>

          <!-- Card: Ventas del mes (órdenes mes + mostrador mes) -->
          <div class="stat-card">
            <div class="card-header">
              <p class="card-label">Ventas del mes</p>
              <!-- ✅ totalMesCompleto calculado en forkJoin cuando ambos datos están listos -->
              <p class="card-value">{{ totalMesCompleto | currency:'COP':'symbol-narrow':'1.0-0' }}</p>
              <div class="trend-indicator">
                <span class="trend-label">Este Mes</span>
                <div class="trend-badge positive">
                  <span class="material-symbols-outlined">bar_chart</span>
                  <span>Global</span>
                </div>
              </div>
            </div>

            <div class="chart-area">
              <svg class="line-chart" viewBox="0 0 472 150" xmlns="http://www.w3.org/2000/svg">
                <path class="chart-stroke"
                  d="M0 137.5C18.15 137.5 18.15 62.5 36.3 62.5C54.46 62.5 54.46 101.5 72.6 101.5C90.77 101.5 90.77 48.5 108.9 48.5C127.08 48.5 127.08 114.5 145.2 114.5C163.38 114.5 163.38 71.5 181.5 71.5C199.7 71.5 199.7 109.5 217.8 109.5C236 109.5 236 29.5 254.1 29.5C272.3 29.5 272.3 1.5 290.4 1.5C308.6 1.5 308.6 120.5 326.7 120.5C344.9 120.5 344.9 83.5 363 83.5C381.2 83.5 381.2 149.5 399.4 149.5C417.5 149.5 417.5 41.5 435.7 41.5C453.8 41.5 453.8 122.5 472 122.5"
                  fill="none" stroke="#fd0100" stroke-width="3" stroke-linecap="round"></path>
              </svg>
            </div>
          </div>

          <!-- Card: Top servicios -->
          <div class="stat-card">
            <div class="card-header">
              <p class="card-label">Lo más vendido del mes</p>
              <p class="card-value truncate">
                {{ stats.top_servicios.length > 0 ? stats.top_servicios[0].nombre_servicio : 'Sin datos' }}
              </p>
              <div class="trend-indicator">
                <span class="trend-label">Top 5</span>
              </div>
            </div>

            <div class="horizontal-bars-container">
              <div class="bar-row" *ngFor="let item of stats.top_servicios">
                <p class="bar-row-label">
                  {{ item.nombre_servicio }}
                  <span class="bar-row-qty">({{ item.total_vendido }})</span>
                </p>
                <div class="progress-track">
                  <div class="progress-fill" [style.width]="getPorcentajeBarra(item.total_vendido)"></div>
                </div>
              </div>

              <div *ngIf="stats.top_servicios.length === 0" class="chart-empty-state">
                No hay ventas registradas este mes.
              </div>
            </div>
          </div>

        </div>
      </section>

      <!-- ======================================================= -->
      <!-- SECCIÓN: Centro de reportes                              -->
      <!-- ======================================================= -->
      <section class="reports-section section-shell" *ngIf="!loading">
        <header class="reports-header">
          <h2>Centro de reportes</h2>
          <p>Control de ventas, inventario, pagos a operarios y exportación en múltiples formatos.</p>
        </header>

        <div class="reports-grid">

          <!-- Reporte de ventas -->
          <article class="report-card">
            <h3>Reporte de ventas</h3>
            <p class="report-desc">Generación de ventas acumuladas y detalle diario del mes.</p>
            <div class="report-kpi-row">
              <div
                style="padding: 1em 1.2em; background: #232323; border-radius: 0.7em; min-width: 220px; box-shadow: 0 1px 4px #0003; border: 1.5px solid #333;">
                <span
                  style="font-weight: 700; font-size: 1.08em; color: #bdbdbd; display: block; margin-bottom: 0.5em; letter-spacing: 0.5px;">
                  Total órdenes
                </span>
                <div id="container-card-reports">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.2em;">
                    <span style="color: #bdbdbd; font-weight: 500;">Cantidad</span>
                    <strong style="font-size: 1.15em; color: #fff;">{{ reporteOperativo.ventas.total_ordenes }}</strong>
                  </div>
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.2em;">
                    <span style="color: #bdbdbd; font-weight: 500;">Total</span>
                    <strong style="font-size: 1.15em; color: #fff;">
                      {{ parseAmount(reporteOperativo.ventas.total_ordenes_dinero) | currency:'COP':'symbol-narrow':'1.0-0' }}
                    </strong>
                  </div>
                </div>
              </div>

              <div
                style="padding: 1em 1.2em; background: #232323; border-radius: 0.7em; min-width: 220px; box-shadow: 0 1px 4px #0003; border: 1.5px solid #333;">
                <span
                  style="font-weight: 700; font-size: 1.08em; color: #bdbdbd; display: block; margin-bottom: 0.5em; letter-spacing: 0.5px;">
                  Total ventas mostrador
                </span>
                <div id="container-card-reports">
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.2em;">
                    <span style="color: #bdbdbd; font-weight: 500;">Cantidad</span>
                    <strong style="font-size: 1.15em; color: #fff;">
                      {{ reporteOperativo.ventas.total_ventas_cantidad }}
                    </strong>
                  </div>
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.2em;">
                    <span style="color: #bdbdbd; font-weight: 500;">Total</span>
                    <strong style="font-size: 1.15em; color: #fff;">
                      {{ parseAmount(reporteOperativo.ventas.total_ventas) | currency:'COP':'symbol-narrow':'1.0-0' }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="daily-sales-list">
              <div *ngFor="let ventaDia of ventasDiariasMes" class="daily-row">
                <span>{{ ventaDia.fecha }}</span>
                <div class="daily-bar-track">
                  <div class="daily-bar-fill" [style.width]="getPorcentajeVentaDia(ventaDia.total)"></div>
                </div>
                <span>{{ parseAmount(ventaDia.total) | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
              </div>
              <div *ngIf="ventasDiariasMes.length === 0" class="muted-empty">
                Sin ventas registradas en el mes actual.
              </div>
            </div>
          </article>

          <!-- Reporte de inventario -->
          <article class="report-card">
            <h3>Reporte de inventario</h3>
            <p class="report-desc">Estado actual de insumos y alertas de stock mínimo.</p>
            <div class="report-kpi-stack">
              <div>
                <span>Insumos registrados</span>
                <strong>{{ reporteOperativo.inventario.total_insumos }}</strong>
              </div>
              <div>
                <span>Stock total</span>
                <strong>{{ reporteOperativo.inventario.stock_total }}</strong>
              </div>
              <div>
                <span>Alertas de stock</span>
                <strong [class.text-danger]="parseAmount(reporteOperativo.inventario.alertas_stock) > 0">
                  {{ reporteOperativo.inventario.alertas_stock }}
                </strong>
              </div>
            </div>
          </article>

          <!-- Exportar reportes -->
          <article class="report-card">
            <h3>Exportar reportes</h3>
            <p class="report-desc">Descarga reportes en formato CSV, Excel o PDF.</p>
            <div class="export-format-row">
              <label for="formato-exporte">Formato</label>
              <select id="formato-exporte" class="export-format-select" [(ngModel)]="formatoExporte">
                <!-- <option value="csv">CSV</option> -->
                <option value="excel">Excel (.xlsx)</option>
                <option value="pdf">PDF</option>
              </select>
            </div>
            <div class="export-grid">
              <button class="btn-export" (click)="exportar('ventas')" [disabled]="exportandoClave !== null">
                {{ exportandoClave === 'ventas-' + formatoExporte ? 'Exportando...' : 'Exportar ventas' }}
              </button>
              <button class="btn-export" (click)="exportar('inventario')" [disabled]="exportandoClave !== null">
                {{ exportandoClave === 'inventario-' + formatoExporte ? 'Exportando...' : 'Exportar inventario' }}
              </button>
            </div>
          </article>

        </div>
      </section>

    </div>
  </main>
</div>